import CreateBoxes from "../components/CreateBoxes";

function Home() {
  return (
    <div>
      <CreateBoxes />
    </div>
  );
}

export default Home;
